// 获取注册协议内容
export const GET_AGREEMENT = "GET_AGREEMENT"


// WEBPACK FOOTER //
// ./src/store/agreement/type.js